import { TransactionalStatusEnum } from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function TransactionPillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '-';

  switch (value) {
    case TransactionalStatusEnum.Active:
      status = 'green';
      text = t(`status:${value}`);
      break;
    case TransactionalStatusEnum.PendingApproval:
    case TransactionalStatusEnum.PendingVoidApproval:
    case TransactionalStatusEnum.VoidDraft:
    case TransactionalStatusEnum.Draft:
      status = 'yellow';
      if (value === TransactionalStatusEnum.Draft) {
        text = t('status:draft');
      } else if (value === TransactionalStatusEnum.PendingApproval) {
        text = t('status:waiting_approval');
      } else if (value === TransactionalStatusEnum.PendingVoidApproval) {
        text = t('status:pending_void');
      } else {
        text = t(`status:${value}`);
      }
      break;

    case TransactionalStatusEnum.RejectedApproval:
      status = 'red';
      if (value === TransactionalStatusEnum.RejectedApproval) {
        text = t('status:rejected');
      }
      break;
    case TransactionalStatusEnum.Void:
      status = 'brown';
      text = t('status:void');
      break;
    case TransactionalStatusEnum.Waiting:
    default:
      if (value === TransactionalStatusEnum.Waiting) text = t('status:waiting');
      if (value === TransactionalStatusEnum.Completed)
        text = t('status:completed');

      status = 'other';
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
